// extracted by mini-css-extract-plugin
export default {"fs":"_12b9d3c29b fccabe6c8c"};